const glass = "backdrop-blur-xl bg-white/[0.04] border border-white/[0.08]";

const glassHov = "hover:bg-white/[0.06] hover:border-white/[0.14]";

/* Tokens below resolve through the CSS custom properties in index.css, which
   flip on prefers-color-scheme. Using vars rather than fixed slate/white
   classes keeps them correct in BOTH themes — the old fixed classes left
   modals dark-on-cream in light mode. */
const glassDeep =
  "backdrop-blur-2xl bg-[var(--bg-surface)] border border-[var(--border-2)] shadow-[var(--shadow-card)]";

const input =
    "w-full bg-[var(--bg-elev)] border border-[var(--border-2)] rounded-lg px-3 py-2 text-sm text-[var(--text-1)] placeholder:text-[var(--text-4)] focus:outline-none focus:border-[var(--text-3)] transition";

const label =
    "text-[10px] uppercase tracking-[0.12em] text-[var(--text-3)] font-medium mb-1.5 block";

const btnP =
    "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium bg-amber-200/90 text-slate-900 hover:bg-amber-200 transition";

const btnG =
    "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm bg-white/[0.04] border border-white/[0.08] text-slate-200 hover:bg-white/[0.08] hover:border-white/[0.14] transition";

const btnD =
    "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-rose-300 transition";

const heading = {
    fontFamily: "Fraunces, Georgia, serif",
    fontFeatureSettings: '"ss01"',
  };

const monoFont = {
    fontFamily: "JetBrains Mono, ui-monospace, monospace",
  };

export { glass, glassHov, glassDeep, input, label, btnP, btnG, btnD, heading, monoFont };
